"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerializedElectricalSchematicViewCollectionSchema = void 0;
const zod_1 = require("zod");
const SerializedElectricalSchematicView_1 = require("./SerializedElectricalSchematicView");
exports.SerializedElectricalSchematicViewCollectionSchema = zod_1.default.object({
    views: zod_1.default.array(SerializedElectricalSchematicView_1.SerializedElectricalSchematicViewSchema),
});
//# sourceMappingURL=SerializedElectricalSchematicViewCollection.js.map